module.exports = __webpack_public_path__ + "assets/img/sy_5g_2_ysx.47bfcceb.png";